import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Discover = lazy(() => import("@/pages/Discover"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/discover")({
  component: () => (
    <ProtectedRoute>
      <Discover />
    </ProtectedRoute>
  ),
});
